import React from "react";
import "./Landing.css";
import buildingimage from "../../images/building-bg.png";
import buildingimagesecond from "../../images/building-bg-right.png";
import linedcircle from "../../images/lined-circle.png";
import circleleft from "../../images/circle-left-bg.png";
import circleright from "../../images/circle-right-bg.png";
import docsend from "../../images/doc-send.svg";
import docsearch from "../../images/doc-search.svg";
import docverified from "../../images/verified.svg";
import datasearch from "../../images/data_search.svg";
import bannerimg from "../../images/hoaverified-banner.svg";
import circlehalf from "../../images/circle-half.png";
import buildingleft from "../../images/img-buildingleft.png";
import property_img from "../../images/table-images.png";
import FooterComponent from "../../Pages/Footer/Footer";
import HeaderComponent from "../../Pages/Header/Header";
import Chatbot from "../Chatbot/Chatbot";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewCommunityGpt,
  fetchCommunityByCommunityName,
  fetchCommunityData,
  getAllCommunityDataPublic,
  getCommunityName
} from "../../Services/Community/CommunityAPI/communityApi";
import {
  fetchTotalWebsiteVisitor
} from "../../Services/TotalWebsiteVisitor/totalWebsiteVisitorApi";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { setId } from "../../Services/Community/CommunitySlice/idSlice";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography, Button } from "@mui/material";
import community_icon from "../../images/Oscar.svg";
import { capitalizeWords } from "../../Utils/LetterCase";
import { toast } from "react-toastify";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { ToastContainer } from "react-bootstrap/esm";
import { GOOGLE_PLACES_API_KEY } from "../../Utils/Constant";
import { debounce } from 'lodash';
import { ThreeDot } from "react-loading-indicators";
import { encryptId } from "../../Utils/Crypto"

const libraries = ["places"]; // Load the Places API library

function LandingComponent() {
  const dispatch = useDispatch();
  // const { data: comm_by_name } = useSelector((state) => state.communityByName);
  const { data: comm_by_name, loading: getNameLoading } = useSelector((state) => state.getCommunityName);
  const { loading } = useSelector((state) => state.createNewCommunityGpt);
  const { data: all_community } = useSelector((state) => state.community);
  const [chatbotActive, setChatBotActive] = useState(false);
  const [communityName, setCommunityName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("")
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();
  const [DefaultQuestion, setDefaultQuestion] = useState(false);
  const [RealEstate, setRealEstate] = useState(false);
  const [MarketInsights, setMarketInsights] = useState(false);
  const [MortgageSolutions, setMortgageSolutions] = useState(false);
  const [Insurancemadeasy, setInsurancemadeeasy] = useState(false);
  const [mes, setMes] = useState("");
  // const [commNameForResp, setCommNameForResp] = useState("");
  // const [active, setActive] = useState(false);
  // const [isValidCommunity, setIsValidCommunity] = useState(true)
  const [communityNameData, setCommunityNameData] = useState([])
  const [showDropDown, setShowDropDown] = useState(false);
  const [locationId, setLocationId] = useState("")
  const [errors, setErrors] = useState({});
  const [id, setId] = useState("")
  const [isGenerated, setIsGenerated] = useState(false);
  const [isSelected, setIsSelected] = useState(false)
  const [isPressed, setIsPressed] = useState(false);

  const messages = [
    "Please wait! We are building your community profile now!",
    "Hang tight! We're setting things up for you!",
    "Just a moment! Your community is being built!",
    "Almost there! Crafting your perfect profile!",
    "Almost ready! Personalizing your community experience!",
    "Hold on! We’re bringing everything together!"
  ];

  // State to keep track of the current message index
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    if (loading) {
      const intervalId = setInterval(() => {
        setShowMessage(false);

        // Wait for the fade-out transition to end, then change message and fade it in
        setTimeout(() => {
          setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
          setShowMessage(true);
        }, 500); // Delay for fade-out (match this with CSS transition time)
      }, 3000); // Change message every 3 seconds

      return () => clearInterval(intervalId);
    }
  }, [loading]);

  useEffect(() => {
    // Debounced function to fetch community data by communityName
    const fetchCommunityName = debounce(async () => {
      if (communityName.trim()) {
        dispatch(getCommunityName(communityName)).then((res) => {
          setCommunityNameData(res?.payload?.data)
          if (res?.payload?.data && !isSelected) {
            setShowDropDown(true)
          } else {
            setShowDropDown(false)
          }
        })
      }
    }, 300);  // Delay of 300ms

    // Call the debounced function when the communityName changes
    fetchCommunityName();

    // Cleanup function to cancel the debounce if communityName changes or component unmounts
    return () => {
      fetchCommunityName.cancel();
    };
  }, [communityName, dispatch]);  // Re-run when communityName changes


  const highlightMatch = (suggestion, query) => {
    const startIndex = suggestion.toLowerCase().indexOf(query.toLowerCase());
    if (startIndex === -1) return suggestion;

    const endIndex = startIndex + query.length;
    return (
      <>
        {suggestion.slice(0, startIndex)}
        <span
          style={{
            // textDecoration: 'underline',
            textDecorationColor: '#dd483b', // Underline color (Orange)
            textDecorationThickness: '2px', // Thicker underline
            textUnderlineOffset: '4px', // Space between the text and underline
            transition: 'all 0.3s ease', // Smooth transition for hover
            fontWeight: 'normal', // Reduce font weight for highlighted text
          }}
        >
          {suggestion.slice(startIndex, endIndex)}
        </span>
        {suggestion.slice(endIndex)}
      </>
    );
  };

  const validateForm = () => {
    const errors = {};
    if (!communityName) {
      errors.community_name = "Please enter a community name";
    }

    if (!city) {
      errors.city = "Please enter a city";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (
      (communityName.trim() || city.trim()) &&
      comm_by_name &&
      comm_by_name?.data?.length > 0
    ) {
      const communityDetails = comm_by_name?.data?.map((community) => ({
        community_name: community?.property_name,
        city: community?.location?.city || "N/A",
        state: community?.location?.state || "N/A",
        id: community?.id
      }));
      setOptions(communityDetails);
      // setShowDropDown(true)
    } else {
      setOptions([]);
      // setShowDropDown(false)
    }
  }, [all_community, communityName, comm_by_name]);

  const handleSelect = (community) => {
    setIsSelected(true)
    setId(community?.id)
    setCommunityName(community?.community_name || "");
    setCity(community?.location?.city || "");
    setInputValue(community?.community_name || "")
    setLocationId(community?.location?.id)
    setIsGenerated(community?.is_generated);
    if (inputValue === communityName) setShowDropDown(false)
  };

  const handleSubmit = async (e) => {
    setMes("")
    if (!inputValueAuto) setShowDropDown(false)
    if (validateForm()) {
      dispatch(
        createNewCommunityGpt({
          community_id: id || null,
          community_name: communityName.trim(),
          community_city: city,
          community_state: state,
          community_zip_code: zipCode,
          location_id: locationId || null,
        })
      )
        // .unwrap()
        .then((res) => {
          if (res?.payload?.status == 404) {
            setMes(
              "Sorry, we were unable to create your community, please contact us for assistance."
            );
          }
          if (res?.payload?.status == 201) {
            toast.success("Community created successfully! You can now view the details.");
            setLocationId("")
            setCity("")
            setState("")
            setZipCode("")
            setId("")
            setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}`); }, 300)
          }
          if (res?.payload?.status == 200) {
            // console.log("res?.payload?", res?.payload)
            // setMes(
            //   "We're sorry, but this community is still in the approval process. Please try again later."
            // );
            setLocationId("")
            setCity("")
            setState("")
            setId("")
            setZipCode("")
            setTimeout(() => { navigate(`/tab/${encryptId(res?.payload?.data?.community_id)}`); }, 300)
          }
          // dispatch(getAllCommunityDataPublic());
          // setCommunityName(commNameForResp); // Update the state to show the new community name
          setInputValue(communityName.trim()); // Ensure the search term matches for filtering
        })
        .catch((error) => {
          console.error(
            "Error fetching community data:",
            error.response || error
          );
        });
    }
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_PLACES_API_KEY, // Replace with your actual API key
    libraries,
  });

  const [autocomplete, setAutocomplete] = useState(null);
  const [inputValueAuto, setInputValueAuto] = useState("");

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();

      setInputValueAuto(place.formatted_address || place.name);

      const addressComponents = place.address_components || [];
      const cityComponent = addressComponents.find(component =>
        component.types.includes("locality")
      );
      const stateComponent = addressComponents.find(component =>
        component.types.includes("administrative_area_level_1")
      );
      const zipCodeComponent = addressComponents.find(component =>
        component.types.includes("postal_code")
      );

      const city = cityComponent?.long_name || "";
      const state = stateComponent?.short_name || "";
      const zipCode = zipCodeComponent?.long_name || null;

      if (city) {
        setCity(city);
        setState(state);
        setZipCode(zipCode);
      }
    }
  };

  if (!isLoaded) {
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <CircularProgress size={50} sx={{ color: "#e55426" }} />
        </Box>
      </div>
    );
  }

  return (
    <>
      <HeaderComponent />
      <section className="one">
        <div className="container">
          {/* <HeaderComponent /> */}
          <div className="banner-content">
            <h1 className="text-center">Al-powered Community Resources</h1>
            <p className="text-center">
              Your gateway to community insights, rules, applications and nearby
              vendors - all in one place for a smoother homeownership
              experience.
            </p>
            <div className="association-content">
              <span>FIND YOUR ASSOCIATION</span>
            </div>
            <div className="landing-searchbar">
              <div className="searchbar-inner-wrapper">
                <div className="inner-searchbar mt-3">
                  <div className="input-searchbar loader-block">
                    <input
                      type="text"
                      name="q"
                      id="community"
                      value={communityName}
                      disabled={loading}
                      onChange={(e) => {
                        const value = e.target.value;
                        // if (value.trim() !== "") {
                        //   setShowDropDown(true);
                        // }
                        // else {
                        //   setShowDropDown(false);
                        // }
                        setCommunityName(value);
                        setInputValue(value);
                        setMes("");
                        setCity("")
                        setInputValueAuto("")
                        setIsSelected(false)
                      }}
                      placeholder="Search by Community Name"
                      autoComplete="off"
                    />
                    <div className="owl_logo_searchbar">
                      <a href="#">
                        <img
                          src={community_icon}
                          alt="owl_logo"
                          width="20"
                          height="20"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
                {showDropDown && inputValue && Object.keys(communityNameData).length !== 0 ? (
                  <div className={`searchbar-content-info-block suggestions ${showDropDown ? 'visible' : ''}`}>
                    {/* <h1>hkjj</h1> */}

                    <div className="content-inner-wrapper">
                      {Array.isArray(communityNameData) &&
                        communityNameData.map((community, index) => (
                          <div className="content-wrapper-box" key={index}>
                            <div
                              className="main-content-block d-flex justify-content-between border-b-2 border-gray-500 py-1"
                              onClick={() => handleSelect(community)}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <div className="community-name-block">
                                {highlightMatch(capitalizeWords(community?.community_name), inputValue)}
                                {/* {capitalizeWords(community?.property_name)} */}
                              </div>
                              <div className="community-city-state">
                                <span className="community-city-name">
                                  {community?.location?.city ? `${community?.location?.city}, ` : ""}
                                </span>
                                <span className="community-state-name">
                                  {community?.location?.state}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                ) : (
                  <div className={`searchbar-content-info-block suggestions ${showDropDown && inputValue ? 'visible' : ''}`}>
                    {/* <h1>hkjj</h1> */}
                    {Object.keys(communityNameData).length === 0 && inputValue ? (
                      <>
                        <div>
                          {/* <div className="horizontl-line mt-2"></div> */}
                          <div className="cant-find-community-block">
                            {!loading && <h6 className="mt-3 mb-3">
                              Can't find your community?
                            </h6>}
                            <div className="input-searchbar-community">
                              <div
                                style={{
                                  display: "flex",
                                  gap: "16px",
                                  alignItems: "center",
                                }}
                              >
                                <div className="input-auto">
                                  <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged} options={{ types: ['(cities)'], componentRestrictions: { country: "us" } }}>

                                    <input
                                      type="text"
                                      placeholder="Type City..."
                                      value={inputValueAuto}
                                      onChange={(e) => setInputValueAuto(e.target.value)}
                                      style={{
                                        width: "100%",
                                        padding: "8px",
                                        fontSize: "16px",
                                        borderRadius: "20px",
                                      }}
                                    />
                                  </Autocomplete>
                                </div>
                                {/* <input
                                  type="text"
                                  name="q"
                                  placeholder="Type City"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setCity(value);
                                    setMes("");
                                    // setInputValue(value);
                                    // setIsDropdownOpen(value.trim() !== "");
                                  }}
                                /> */}
                                {errors.city && (
                                  <div className="error-text">
                                    {errors.city}
                                  </div>
                                )}
                                {/* <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "#DD483B",
                                    color: "#ffffff",
                                    borderRadius: "20px",
                                    cursor: loading ? "not-allowed" : "pointer",
                                    opacity: loading ? 0.7 : 1,
                                  }}
                                  onClick={handleSubmit}
                                  disabled={loading}
                                >
                                  Submit
                                </Button> */}
                              </div>

                              {/* {errors.community_name && (
                                <div className="error-text">
                                  {errors.community_name}
                                </div>
                              )} */}
                              {/* {loading && (
                                <div className="message_from_admin mt-4">
                                  Please wait! We are building your community
                                  profile now!
                                </div>
                              )} */}
                            </div>
                            {loading && (
                              // <div className="message_from_admin mt-4 text-center">
                              //   <div className={`message-from-admin ${showMessage ? 'fade-in' : 'fade-out'}`}>
                              //     {/* {messages[0]} */}
                              //     <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                              //   </div>
                              // </div>
                              <div className="message_from_admin mt-4 text-center">
                                <div className={`message-from-admin mb-2`}>
                                  {messages[0]}
                                </div>
                                <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                              </div>
                            )}
                            <h6 className="mt-3 mb-3">{mes}</h6>
                          </div>
                        </div>
                      </>
                    ) : <></>}
                  </div>
                )}
                {!inputValueAuto && (
                  <>
                    {loading && !isGenerated && (
                      <div className="message_from_admin mt-4 text-center">
                        {/* <div className={`message-from-admin mb-2 ${showMessage ? 'fade-in' : 'fade-out'}`}>
                          {messages[currentMessageIndex]}
                        </div> */}
                        <div className={`message-from-admin mb-2`}>
                          {messages[0]}
                        </div>
                        <ThreeDot color="#dd483b" size="small" text="" textColor="" />
                      </div>
                    )}
                    {mes && (
                      <div className="message_from_admin mt-4 text-center">
                        {mes}
                      </div>
                    )}
                  </>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "15px",
                  }}
                >
                  {/* <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#DD483B",
                      color: "#ffffff",
                      borderRadius: "20px",
                      cursor: loading ? "not-allowed" : "pointer",
                      opacity: loading ? 0.7 : 1,
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button> */}
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "50px",
                      px: 4,
                      py: 1,
                      backgroundColor: "#DD483B",
                      cursor: loading ? "not-allowed" : "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      textTransform: "none",
                      color: "white",
                      "&.Mui-disabled": {
                        backgroundColor: "#f57269",
                        color: "#fbd3d3",
                        opacity: 1,
                      },
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                    {/* Sumbit */}
                  </Button>

                </div>

                {/* <div className="searchbar-parent-block mt-5 d-flex gap-2 justify-content-center flex-wrap text-center">
                  <div
                    href="#"
                    className="landing-searchbar-boxes"
                    onClick={() => {
                      setChatBotActive(!chatbotActive);
                      setRealEstate(true);
                    }}
                  >
                    <div className="searchboxes-title">
                      <p className="title-info-para m-0 p-0">
                        Real Estate<br></br>Q&A
                      </p>
                    </div>
                    <div className="icons-for-searchboxes">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 512 512"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            d="M256 0C114.509 0 0 114.496 0 256c0 141.489 114.496 256 256 256 141.491 0 256-114.496 256-256C512 114.509 397.504 0 256 0zm0 476.279c-121.462 0-220.279-98.816-220.279-220.279S134.538 35.721 256 35.721c121.463 0 220.279 98.816 220.279 220.279S377.463 476.279 256 476.279z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                          <path
                            d="M248.425 323.924c-14.153 0-25.61 11.794-25.61 25.946 0 13.817 11.12 25.948 25.61 25.948s25.946-12.131 25.946-25.948c0-14.152-11.794-25.946-25.946-25.946zM252.805 127.469c-45.492 0-66.384 26.959-66.384 45.155 0 13.142 11.12 19.208 20.218 19.208 18.197 0 10.784-25.948 45.155-25.948 16.848 0 30.328 7.414 30.328 22.915 0 18.196-18.871 28.642-29.991 38.077-9.773 8.423-22.577 22.24-22.577 51.22 0 17.522 4.718 22.577 18.533 22.577 16.511 0 19.881-7.413 19.881-13.817 0-17.522.337-27.631 18.871-42.121 9.098-7.076 37.74-29.991 37.74-61.666s-28.642-55.6-71.774-55.6z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div
                    href="#"
                    className="landing-searchbar-boxes"
                    onClick={() => {
                      setChatBotActive(!chatbotActive);
                      setMarketInsights(true);
                    }}
                  >
                    <div className="searchboxes-title">
                      <p className="title-info-para m-0 p-0">
                        Market<br></br>Insights
                      </p>
                    </div>
                    <div className="icons-for-searchboxes">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 32 32"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            d="M24 2v2h2.586L16 14.586l-4-4-9.707 9.707 1.414 1.414L12 13.414l4 4 12-12V8h2V2zM8.414 23H3.586L2 24.586V30h8v-5.414zM13.59 19 12 20.59V30h8v-9.41L18.41 19zM23.59 13 22 14.59V30h8V14.59L28.41 13z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div
                    href="#"
                    className="landing-searchbar-boxes"
                    onClick={() => {
                      setChatBotActive(!chatbotActive);
                      setMortgageSolutions(true);
                    }}
                  >
                    <div className="searchboxes-title">
                      <p className="title-info-para m-0 p-0">
                        Mortgage<br></br>Solutions
                      </p>
                    </div>
                    <div className="icons-for-searchboxes">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 48 48"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            d="M44 31v-9.6a3 3 0 0 0 4-2.81c0-1.7.29-.94-16.17-17.42a4 4 0 0 0-5.66 0C9.79 17.57 10 16.87 10 18.59a3 3 0 0 0 4 2.79v6c-1.55-.1-1.93 0-6 .53V27a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1c1.65 0 2.56-.11 3.77.45 15 6.8 11.11 6.84 34.06-4.89A4 4 0 0 0 44 31ZM12.3 17.88 27.58 2.59a2.05 2.05 0 0 1 2.84 0C47.06 19.24 46 18 46 18.59a1 1 0 0 1-1.7.7L29.71 4.71a1 1 0 0 0-1.42 0L13.7 19.29a1 1 0 0 1-1.4-1.41Zm3.7 1.94 13-13 13 13v11.71l-11 5.62a4 4 0 0 0-2.29-3.77C17.13 27.94 17.56 28.05 16 27.65ZM6 43H2V28h4Zm38.92-6.22C27.42 45.72 27.56 46 24.72 46a9.32 9.32 0 0 1-4.26-.8C10.35 40.61 12 41 8 41V29.88c8.23-1 5.45-1.46 19.85 5.3a2 2 0 0 1-1.7 3.63l-7.89-3.71a1 1 0 0 0-.86 1.8l7.89 3.71a3.92 3.92 0 0 0 3.93-.3l13.86-7.09a2 2 0 1 1 1.84 3.56Z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                          <path
                            d="M24 28c.6 0-.1.51 10.71-10.29a1 1 0 0 0-1.42-1.42l-10 10A1 1 0 0 0 24 28ZM26 21a3 3 0 1 0-3-3 3 3 0 0 0 3 3Zm0-4a1 1 0 0 1 0 2 1 1 0 0 1 0-2ZM32 23a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4a1 1 0 0 1 0-2 1 1 0 0 1 0 2Z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div
                    href="#"
                    className="landing-searchbar-boxes"
                    onClick={() => {
                      setChatBotActive(!chatbotActive);
                      setInsurancemadeeasy(true);
                    }}
                  >
                    <div className="searchboxes-title">
                      <p className="title-info-para m-0 p-0">
                        Insurance<br></br>made easy
                      </p>
                    </div>
                    <div className="icons-for-searchboxes">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="20"
                        height="20"
                        x="0"
                        y="0"
                        viewBox="0 0 509.715 509.715"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            d="M254.857.564 0 187.045l17.715 24.211L254.857 37.738 492 211.256l17.715-24.211zM301.756 221.875H207.96c-5.439 21.055-22.048 37.664-43.102 43.104v.967c0 66.324 34.269 128.158 90 163.428 55.73-35.27 90-97.104 90-163.428v-.967c-21.054-5.44-37.664-22.049-43.102-43.104zm-61.899 128.213-38.606-38.605 21.213-21.213 17.394 17.393 43.394-43.393 21.213 21.213z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                          <path
                            d="M59.857 217.594V509.15h390V217.594l-195-142.683zm300 19.281h15v29.07c0 79.965-43.13 154.283-112.559 193.955l-7.441 4.25-7.441-4.25c-69.429-39.67-112.559-113.99-112.559-193.955v-29.07h15c16.542 0 30-13.457 30-30v-15h150v15c0 16.543 13.458 30 30 30z"
                            fill="#000000"
                            opacity="1"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div> */}
                <div className="oscar_title mt-3 text-center">
                  <p className="m-0 p-0">
                    Ask OSCAR: The Smarter Way to Navigate Real Estate
                  </p>
                </div>
                <div className="chatbot-wrapper">
                  <div
                    className={`chatbot-button ${isPressed ? 'pressed' : ''}`}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                  >
                    {/* Chat icon */}
                    <div
                      className="owl-logo-lower-blk text-center"
                      onClick={() => {
                        setChatBotActive(!chatbotActive)
                        setDefaultQuestion(true)
                      }}
                    >
                      <div>
                        <a href="#">
                          <img
                            src={community_icon}
                            alt="owl_logo"
                            width="50"
                            height="50"
                          ></img>
                        </a>
                      </div>
                    </div>

                    {/* Ripple effect */}
                    <div className="ripple-container">
                      <div className="ripple-circle delay-0"></div>
                      <div className="ripple-circle delay-400"></div>
                      <div className="ripple-circle delay-800"></div>
                    </div>
                  </div>
                </div>

                {chatbotActive && (
                  <Chatbot
                    setChatBotActive={setChatBotActive}
                    DefaultQuestion={DefaultQuestion}
                    RealEstate={RealEstate}
                    MarketInsights={MarketInsights}
                    MortgageSolutions={MortgageSolutions}
                    Insurancemadeeasy={Insurancemadeasy}
                    setDefaultQuestion={setDefaultQuestion}
                    setRealEstate={setRealEstate}
                    setMarketInsights={setMarketInsights}
                    setMortgageSolutions={setMortgageSolutions}
                    setInsurancemadeeasy={setInsurancemadeeasy}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="building-block-left">
          <img src={buildingimage} alt="building-pic"></img>
        </div>
        <div className="building-block-right">
          <img src={buildingimagesecond} alt="building-pic"></img>
        </div>
        <div className="circle-bg">
          <img src={linedcircle} alt="circle-img"></img>
        </div>
      </section >
      <section className="two text-center">
        <div className="container">
          <div className="streamline-content">
            <h2>
              Streamline Compliance with<br></br> AI-Powered Tools
            </h2>
            <div className="horizontal-line"></div>
            <p>
              Transform how your homeowners’ association or property management
              company navigates compliance with our Al-powered assessment tools.
              Designed to simplify adherence to local and state regulations,
              these tools streamline the compliance process, enhance
              communication with residents, and provide actionable insights for
              informed decision-making. With easy document management and
              customizable reports, you can reduce administrative burdens and
              focus on what matters most-creating a thriving community.
            </p>
          </div>
        </div>
        <div className="circle-left">
          <img src={circleleft} alt="circle-img"></img>
        </div>
        <div className="circle-right">
          <img src={circleright} alt="circle-img"></img>
        </div>
      </section>
      <section className="three">
        <div className="container">
          <h2>The HOA Verified Process: Simplifying Compliance</h2>
        </div>
      </section>
      <section className="four">
        <div className="container">
          <div className="document-block">
            <div className="doc-inner-block">
              <div className="box">
                <div className="box-inner text-center">
                  <img src={docsend} alt="document-send"></img>
                  <span>Upload Documents</span>
                  <p>
                    Easily upload your community's legal documents for analysis.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={docsearch} alt="document-search"></img>
                  <span>Receive Analysis & Assessment</span>
                  <p>
                    Get comprehensive insights into your documents' compliance
                    with local & state regulations.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={docverified} alt="document-verification"></img>
                  <span>Get Recommended Solutions</span>
                  <p>
                    Receive tailored solutions to address any compliance gaps or
                    updates needed.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="box-inner text-center">
                  <img src={datasearch} alt="document-analysis"></img>
                  <span>Online Monitoring for Legal Changes</span>
                  <p>
                    Stay informed with real-time alerts about changes in local
                    and state laws and how they affect your organization's legal
                    documents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="five">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="left-block">
                <h2>
                  Effortless Community Profiles with AI-Powered Convenience
                </h2>
                <p>
                  Once your documents are uploaded, HOA Verified's AI instantly
                  creates a comprehensive community profile featuring
                  easy-to-understand summaries, accessible applications, and
                  authentic reviews. Home shoppers and realtors can ask
                  questions and receive instant answers, along with details on
                  nearby vendors like dining, services, and amenities. This
                  streamlined experience reduces calls and emails from
                  non-residents, giving associations and property managers more
                  time to focus on their core responsibilities.
                </p>
                <button className="btn btn-outline get-started" type="submit">
                  Get Started{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="#222222"
                  >
                    <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                  </svg>
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-block">
                <img src={bannerimg} alt=""></img>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="six">
        <div className="container">
          <div className="free-trial-box text-center">
            <h2>Start Your 30-Day Free Trial</h2>
            <p>
              Protect your association from legal risks, streamline<br></br>{" "}
              operations, and stay compliant—all for free.
            </p>
            <div className="button-area d-flex justify-content-center">
              <button className="btn btn-outline contact-us" type="submit">
                Contact us{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#222222"
                >
                  <g id="arrow-right-up-line">
                    <path
                      id="Vector"
                      d="M13.9137 10.7054L3.77688 11.0594L3.71871 9.39376L13.8555 9.03977L9.23227 4.72853L10.3689 3.50961L17.073 9.76124L10.8213 16.4653L9.60241 15.3287L13.9137 10.7054Z"
                      fill=""
                    ></path>
                  </g>
                </svg>
              </button>
              <button className="btn btn-outline get-started-trail" type="submit">
                Get Started{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#ffffff"
                >
                  <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="half-circle">
          <img src={circlehalf} alt="half-circle"></img>
        </div>
        <div className="building-bg-area">
          <img src={buildingleft} alt="building"></img>
        </div>
      </section>
      <FooterComponent />

    </>
  );
}

export default LandingComponent;
